<script setup lang="ts">
  import IconBase from './IconBase.vue'
  withDefaults(
    defineProps<{
      color?: string
      height?: number | string
      viewBoxValue?: string
      width?: number | string
    }>(),
    {
      width: 15,
      height: 15,
      color: 'currentColor',
      viewBoxValue: `0 0 32 32`,
    },
  )
</script>

<template>
  <IconBase
    :width="width"
    :height="height"
    :color="color"
    :view-box-value="viewBoxValue"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M7 26H25C26.1046 26 27 25.1046 27 24V12.5H5V24C5 25.1046 5.89543 26 7 26Z"
        fill="#98A2B3"
      />
      <path
        d="M12.8229 6H7C5.89543 6 5 6.89543 5 8V12.5H27V11C27 9.89543 26.1046 9 25 9H17.6771C16.6492 9 15.7097 8.4193 15.25 7.5C14.7903 6.5807 13.8508 6 12.8229 6Z"
        fill="#667085"
      />
    </svg>
  </IconBase>
</template>

<style scoped lang="scss"></style>
